import styled from 'styled-components';

export const NotificationWrapper = styled.div`
  position: fixed;
  bottom: 20px;
  right: 20px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
  padding: 16px;
  width: 380px;
  z-index: 2000;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
`;

export const NotificationHeader = styled.div`
  display: flex;
  gap: 12px;
  align-items: flex-start;
  flex: 1;
`;

export const NotificationContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
`;

export const StatusText = styled.div`
  font-family: 'Manrope', sans-serif;
  font-weight: 500;
  font-size: 13px;
  line-height: 20px;
  color: ${({ success, error }) => {
    if (error) return '#DC3545';
    return success ? '#48566B' : '#1B2028';
  }};
  display: flex;
  align-items: center;
`;

export const ProgressText = styled.div`
  font-family: 'Manrope', sans-serif;
  font-weight: 400;
  font-size: 11px;
  line-height: 100%;
  color: #5A6C87;
  margin-top: 4px;
`;

export const ProgressBar = styled.div`
  width: 100%;
  height: 8px;
  background-color: #E3F0FF;
  border-radius: 4px;
  overflow: hidden;
  margin-top: 8px;
`;

export const ProgressFill = styled.div`
  width: ${({ progress }) => progress}%;
  height: 100%;
  background-color: #0C53BB;
  border-radius: 4px;
  transition: width 0.3s ease;
`;

export const ActionLink = styled.button`
  font-family: 'Manrope', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #0C53BB;
  background: none;
  border: none;
  cursor: pointer;
  text-align: left;
  transition: color 0.2s;

  &:hover {
    color: #084080;
    text-decoration: underline;
  }
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #5A6C87;
  flex-shrink: 0;
  transition: background-color 0.2s;
  border-radius: 4px;

  &:hover {
    background-color: #F3F4F7;
  }
`;

export const ErrorMessage = styled.div`
  font-family: 'Manrope', sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #DC3545;
  margin-top: 4px;
  word-wrap: break-word;
`;

